{
  "field": {
    "recounted": "Is er herteld?",
    "number_of_voters": "Kiesgerechtigden",
    "voters_counts": {
      "poll_card_count": "Stempassen",
      "proxy_certificate_count": "Volmachtbewijzen",
      "total_admitted_voters_count": "Totaal toegelaten kiezers"
    },
    "votes_counts": {
      "blank_votes_count": "Blanco stemmen",
      "invalid_votes_count": "Ongeldige stemmen",
      "total_votes_cast_count": "Totaal uitgebrachte stemmen",
      "total_votes_candidates_count": "Totaal stemmen op kandidaten"
    },
    "differences_counts": {
      "fewer_ballots_count": "Aantal minder getelde stemmen",
      "more_ballots_count": "Aantal méér getelde stemmen"
    }
  }
}
